import CryptoJS from 'crypto-js'
import { Base64 } from '../assets/common/js/config'
//秘钥, 建议设置其他的字符, 这里只是为了演示，一般长度是16位
var key = CryptoJS.enc.Utf8.parse('GftZqNEoBVdB2kwx')
// 偏移量, 建议设置其他的字符, 这里只是为了演示，一般长度是16位
var iv = CryptoJS.enc.Utf8.parse('3zyJFPEzh5rUeUNi')
export default {
  //加密
  encryptAES(text) {
    let ciphertext = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(typeof text == 'string' ? text : JSON.stringify(text)),
      key,
      {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    ).toString()
    return this.replaceAES(ciphertext)
  },
  //解密
  decryptAES(encrypted) {
    var decrypted = CryptoJS.AES.decrypt(this.replaceAES2(encrypted), key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    })
    return decrypted.toString(CryptoJS.enc.Utf8)
  },
  replaceAES(str) {
    var data = str
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/\=/g, '')
    return data
  },
  replaceAES2(str) {
    var data = str.replace(/\-/g, '+').replace(/\_/g, '/')
    return data
  }
}



// WEBPACK FOOTER //
// ./src/axiosApi/encrypt.js